const IconFilterArrows = ({ className }) => {
    return (
        <svg
            width='18'
            height='17'
            viewBox='0 0 18 17'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <g>
                <path
                    id='Vector'
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M5.03905 3.15611C5.30645 2.8887 5.73999 2.8887 6.00739 3.15611L8.74628 5.89499C9.01368 6.1624 9.01368 6.59594 8.74628 6.86334C8.47888 7.13074 8.04534 7.13074 7.77794 6.86334L6.20794 5.29334V13.2264C6.20794 13.6046 5.90138 13.9111 5.52322 13.9111C5.14506 13.9111 4.8385 13.6046 4.8385 13.2264V5.29334L3.2685 6.86334C3.0011 7.13074 2.56756 7.13074 2.30016 6.86334C2.03276 6.59594 2.03276 6.1624 2.30016 5.89499L5.03905 3.15611ZM12.3704 2.95555C12.7486 2.95555 13.0552 3.26212 13.0552 3.64028V11.5733L14.6252 10.0033C14.8926 9.73593 15.3261 9.73593 15.5935 10.0033C15.8609 10.2707 15.8609 10.7043 15.5935 10.9717L12.8546 13.7106C12.5872 13.978 12.1537 13.978 11.8863 13.7106L9.14738 10.9717C8.87998 10.7043 8.87998 10.2707 9.14738 10.0033C9.41478 9.73593 9.84833 9.73593 10.1157 10.0033L11.6857 11.5733V3.64028C11.6857 3.26212 11.9923 2.95555 12.3704 2.95555Z'
                />
            </g>
        </svg>
    );
};

export default IconFilterArrows;
